import { render } from "./CommunityProfiles.vue?vue&type=template&id=23511588"
import script from "./CommunityProfiles.vue?vue&type=script&lang=js"
export * from "./CommunityProfiles.vue?vue&type=script&lang=js"

import "./CommunityProfiles.vue?vue&type=style&index=0&id=23511588&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__